var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMusicHeadphones(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.938,
    y1: 469.197,
    x2: 236.938,
    y2: 408.967,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5323)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5B6A6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#303033"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M412.098,149.813l-4.721,1.542c-15.229,4.975-32.015-0.398-41.302-13.453 C341.583,103.48,301.369,80.984,256,80.984s-85.583,22.496-110.074,56.919c-9.287,13.054-26.074,18.428-41.302,13.453l-4.721-1.542 c10.348-24.3,26.209-45.711,46.01-62.635C175.547,61.793,214.025,46.456,256,46.456s80.454,15.337,110.089,40.722 C385.889,104.102,401.75,125.513,412.098,149.813z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.9375,
    y1: 485.657,
    x2: 236.9375,
    y2: 335.687,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5323)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCF95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    style: {
      stopColor: "#FFC954"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC200"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M471.753,278.877h-43.941v-50.01c0-94.737-77.074-171.81-171.811-171.81 S84.189,134.131,84.189,228.868v50.01H40.247v-50.01c0-118.966,96.786-215.753,215.753-215.753s215.753,96.786,215.753,215.753 V278.877z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.9375,
    y1: 604.847,
    x2: 236.9375,
    y2: 239.297,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5323)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC200",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    style: {
      stopColor: "#FFBB00",
      stopOpacity: 0.203
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    style: {
      stopColor: "#FFA700",
      stopOpacity: 0.499
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    style: {
      stopColor: "#FF8800",
      stopOpacity: 0.852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7800"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M446.643,278.877v-50.01c0-105.121-85.522-190.643-190.643-190.643 S65.357,123.747,65.357,228.868v50.01h-6.277v-50.01c0-108.581,88.338-196.921,196.921-196.921s196.921,88.338,196.921,196.921 v50.01H446.643z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.9375,
    y1: 493.507,
    x2: 236.9375,
    y2: 344.447,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5323)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8EFEE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    d: "M256,45.358c-100.59,0-182.427,81.836-182.427,182.427v51.092h10.615v-50.01 c0-94.737,77.074-171.81,171.811-171.81s171.811,77.073,171.811,171.81v50.01h10.615v-51.092 C438.427,127.194,356.59,45.358,256,45.358z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 268.3327,
    y1: 346.2865,
    x2: 211.8027,
    y2: 286.0565,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5323)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5B6A6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#303033"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    d: "M141.751,351.478v52.327c0,8.017,3.134,15.717,8.732,21.457l0,0 c5.598,5.739,8.732,13.439,8.732,21.457v8.612c0,24.053-19.499,43.553-43.553,43.553H83.886V261.61h31.776 c24.053,0,43.553,19.499,43.553,43.553v3.402c0,8.017-3.134,15.717-8.732,21.457l0,0 C144.885,335.761,141.751,343.461,141.751,351.478z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.6475,
    y1: 228.287,
    x2: 50.6475,
    y2: 57.947,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5323)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCF95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    style: {
      stopColor: "#FFC954"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC200"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_6_)"
    },
    d: "M83.887,498.883H51.151c-11.298,0-20.457-9.158-20.457-20.457V282.065 c0-11.298,9.158-20.457,20.457-20.457h32.736V498.883z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.325,
    y1: 135.247,
    x2: 11.325,
    y2: 263.427,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5323)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCF95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    style: {
      stopColor: "#FFC954"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC200"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_7_)"
    },
    d: "M9.185,451.836l21.508,28.244V280.41L9.185,308.655C3.227,316.48,0,326.043,0,335.878v88.736 C0,434.449,3.227,444.011,9.185,451.836z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.4713,
    y1: 603.7599,
    x2: 73.2913,
    y2: 238.2099,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5323)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC200",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    style: {
      stopColor: "#FFBB00",
      stopOpacity: 0.203
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    style: {
      stopColor: "#FFA700",
      stopOpacity: 0.499
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    style: {
      stopColor: "#FF8800",
      stopOpacity: 0.852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7800"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 69.261,
    y: 261.61,
    style: {
      fill: "url(#SVGID_8_)"
    },
    width: 14.626,
    height: 237.269
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.647,
    y1: 85.864,
    x2: 50.647,
    y2: 52.404,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5323)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC200",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    style: {
      stopColor: "#FFBB00",
      stopOpacity: 0.203
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    style: {
      stopColor: "#FFA700",
      stopOpacity: 0.499
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    style: {
      stopColor: "#FF8800",
      stopOpacity: 0.852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7800"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_9_)"
    },
    d: "M30.693,465.944v12.482c0,11.298,9.158,20.457,20.457,20.457h32.737v-32.939H30.693z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.276,
    y1: 80.957,
    x2: 110.276,
    y2: 63.297,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5323)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5B6A6A",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#303033"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_10_)"
    },
    d: "M83.887,465.944v32.939h31.773c20.391,0,37.503-14.016,42.242-32.939H83.887z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 532.7337,
    y1: 334.7318,
    x2: 476.2037,
    y2: 274.5018,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5323)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5B6A6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#303033"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_11_)"
    },
    d: "M428.114,261.61v237.273h-31.776c-24.053,0-43.553-19.499-43.553-43.553v-8.612 c0-8.017,3.134-15.717,8.732-21.457l0,0c5.598-5.739,8.732-13.439,8.732-21.457v-52.327c0-8.017-3.134-15.717-8.732-21.457l0,0 c-5.598-5.739-8.732-13.439-8.732-21.457v-3.402c0-24.053,19.499-43.553,43.553-43.553h31.776V261.61z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 423.2275,
    y1: 228.287,
    x2: 423.2275,
    y2: 57.947,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5323)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCF95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    style: {
      stopColor: "#FFC954"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC200"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_12_)"
    },
    d: "M428.113,498.883h32.736c11.298,0,20.457-9.158,20.457-20.457V282.065 c0-11.298-9.158-20.457-20.457-20.457h-32.736V498.883z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 462.55,
    y1: 135.247,
    x2: 462.55,
    y2: 263.427,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5323)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCF95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    style: {
      stopColor: "#FFC954"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC200"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_13_)"
    },
    d: "M502.815,451.836l-21.508,28.244V280.41l21.508,28.244 c5.958,7.824,9.185,17.388,9.185,27.222v88.736C512,434.449,508.773,444.011,502.815,451.836z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 377.4077,
    y1: 603.7601,
    x2: 400.5877,
    y2: 238.2101,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5323)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC200",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    style: {
      stopColor: "#FFBB00",
      stopOpacity: 0.203
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    style: {
      stopColor: "#FFA700",
      stopOpacity: 0.499
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    style: {
      stopColor: "#FF8800",
      stopOpacity: 0.852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7800"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 428.117,
    y: 261.61,
    style: {
      fill: "url(#SVGID_14_)"
    },
    width: 14.626,
    height: 237.269
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 423.2285,
    y1: 85.864,
    x2: 423.2285,
    y2: 52.404,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5323)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC200",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    style: {
      stopColor: "#FFBB00",
      stopOpacity: 0.203
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    style: {
      stopColor: "#FFA700",
      stopOpacity: 0.499
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    style: {
      stopColor: "#FF8800",
      stopOpacity: 0.852
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7800"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_15_)"
    },
    d: "M481.307,465.944v12.482c0,11.298-9.158,20.457-20.457,20.457h-32.736v-32.939H481.307z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 363.599,
    y1: 80.957,
    x2: 363.599,
    y2: 63.297,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5323)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5B6A6A",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#303033"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_16_)"
    },
    d: "M428.113,465.944v32.939H396.34c-20.391,0-37.503-14.016-42.242-32.939H428.113z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMusicHeadphones);
export default __webpack_public_path__ + "static/media/icon-music-headphones.f2c5357421ebd0162ea7af60afbc2c49.svg";
export { ForwardRef as ReactComponent };